// CLDR's compact patterns mix case by magnitude bucket under es-CL (2,5 K but
// 10 k), so the unit letter is normalized instead of trusting Intl to stay
// consistent within a single axis. formatToParts isolates that letter from the
// digits and currency symbol so only it gets rewritten. The narrow symbol of USD
// is a bare "$", which reads as pesos, so it is written "US$" as formatMoney does.
export function formatCompactAmount(
  value: number,
  locale: string,
  currency?: string | null,
  maximumFractionDigits = 1,
) {
  const formatter = new Intl.NumberFormat(locale, {
    style: currency ? 'currency' : 'decimal',
    currency: currency ?? undefined,
    currencyDisplay: 'narrowSymbol',
    notation: 'compact',
    maximumFractionDigits,
  });

  return formatter
    .formatToParts(value)
    .map((part) => {
      if (part.type === 'compact') return part.value.toUpperCase();
      if (part.type === 'currency' && currency === 'USD') return 'US$';
      return part.value;
    })
    .join('');
}

/* Width for a chart axis of compact amounts. Recharts' default of 60 px cuts the
   "US$" prefix of a dollar label. The rest get 60 explicitly: Recharts spreads the
   axis props over its defaults, so passing width={undefined} erases the default
   and the chart lays out with NaN. */
export const compactAxisWidth = (currency?: string | null) => (currency === 'USD' ? 72 : 60);
